import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import request from '@/utils/request';
import API from '@/config/api';
import type { DeviceRecord } from '@/types/log.types';
import { fetchDevicesRequest, fetchDevicesSuccess, fetchDevicesFailure } from './devicesSlice';

function* handleFetchDevices(action: PayloadAction<{ page: number; limit: number; search?: string; sortField?: string; sortOrder?: string }>) {
  try {
    const { page, limit, search, sortField, sortOrder } = action.payload;
    const body: Record<string, unknown> = { page, limit };
    if (search) body.search = search;
    if (sortField) body.sortField = sortField;
    if (sortOrder) body.sortOrder = sortOrder;
    
    const res: { data: { data: { data: DeviceRecord[]; count: number } } } = yield call(request.post, API.DEVICES, body);
    // API returns data.data as array and data.count for total
    const dataArray = res.data.data?.data || [];
    const totalCount = res.data.data?.count || 0;
    yield put(fetchDevicesSuccess({ list: dataArray, totalCount }));
  } catch (e: unknown) {
    yield put(fetchDevicesFailure(e instanceof Error ? e.message : 'Failed'));
  }
}

export default function* devicesSaga() {
  yield takeLatest(fetchDevicesRequest.type, handleFetchDevices);
}
